var app = require('../index');

app.fn('usage.switchTab', function(e, el, next, dom) {
	var statType = el.rel;
	$('#statType').val(statType);
	$('#usage-form').submit();
});